import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable";
import { getCollections, getExpandedCollections, getProducts } from "../services/ProductsService";
import CollectionsDropdown from "../components/CollectionsDropdown";
import { useQuery, useQueryCache } from "react-query";
import {
  BrandFilter,
  BrandSpecificFilters,
} from "../components/BrandSpecificFilters";
import { Item } from "../types/Item";
import { CSVDownload } from "../components/CSVDownload";
import { Button } from "antd";

const Sourcing: React.FC = () => {
  const [collection, setCollection] = useState<string>("");
  const [expanded, setExpanded] = useState<boolean>(false)
  const { data, isLoading } = useQuery(collection, (collection: string) =>
    collection ? getProducts(collection, expanded) : null
  );
  const [filteredData, setFilteredData] = useState<Item[]>([]);
  const [exportData, setExportData] = useState<Item[]>([]);
  const [filters, setFilters] = useState<BrandFilter[]>([]);
  const queryCache = useQueryCache()

  const setFiltersWithLocalStorage = (filters: BrandFilter[]) => {
    setFilters(filters);
    window.localStorage.setItem(
      `${collection}_filters`,
      JSON.stringify(filters)
    );
  };

  useEffect(() => {
    const filtersStr = window.localStorage.getItem(`${collection}_filters`);
    if (filtersStr) {
      setFilters(JSON.parse(filtersStr));
    } else if (
      [
        "dickssportinggoods",
        "eastbay",
        "champssports",
        "finalscore",
        "footaction",
        "footlocker",
      ].includes(collection)
    ) {
      setFilters([
        { brand: "Nike", minDiscount: 19 },
        { brand: "", minDiscount: 24 },
      ]);
    } else {
      setFilters([]);
    }
  }, [collection]);

  useEffect(() => {
    let appendedFilters = filters;
    console.log('Current filters:', filters)
    if (!filters.find((filter) => filter.brand === ""))
      appendedFilters = [...appendedFilters, { brand: "", minDiscount: -1 }];
    setFilteredData(
      data?.filter((item) =>
        appendedFilters
          .map(({ brand, minDiscount }) =>
            item.name?.toLowerCase().includes(brand.toLowerCase())
              ? item.percentOff >= minDiscount
              : true
          )
          .reduce((a, b) => a && b, true)
      ) || []
    );
  }, [filters, data]);

  useEffect(() => {
    setExportData(filteredData)
  }, [filteredData])

  useEffect(() => {
    console.log('invalidating');
    queryCache.invalidateQueries('collections')
  }, [expanded, queryCache])

  return (
    <>
      <div style={{ display: "flex" }}>
        <CollectionsDropdown queryKey={expanded ? "expandedSourcing" : "defaultSourcing"} onChange={(x) => setCollection(x)} getCollections={() => expanded ? getExpandedCollections() : getCollections()} />
        <CSVDownload
          data={exportData}
          isLoading={isLoading}
          collection={collection}
        />
        <Button onClick={() => setExpanded((expanded) => !expanded)} >{expanded ? 'Simple Mode' : 'Expert Mode'}</Button>
      </div>
      <BrandSpecificFilters
        filters={filters}
        setFilters={setFiltersWithLocalStorage}
      />
      <DataTable expanded={expanded} loading={isLoading} data={filteredData} changeFilteredData={setExportData} />
    </>
  );
};

export default Sourcing;
